import React, { useState } from 'react'
import OrderModal from 'app/features/orders/componentsv1/view/orderModal/OrderModal'
import { useDispatch } from 'react-redux'
import { showMessage } from 'app/redux/messageSlice'
import { useParams } from 'react-router-dom'
import ordersService from 'app/services/OrdersService/OrdersService'
import { setOrderNotes } from '../../redux/order/orderSlice'

interface Props {
  onClose: () => void
  value: Record<string, any> | any
}

export const CustomerNewNote: React.FC<Props> = ({onClose, value}) => {
  const dispatch = useDispatch()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [note, setNote] = useState(value?.title)
  const {orderId}: any = useParams()

  const handleSaveNote = async () => {
    try {
      setIsSubmitting(true)
      const notes = await ordersService.createOrderNotes(orderId, note)
      dispatch(setOrderNotes(notes))
      dispatch(
        showMessage({
          text: 'Your order notes has been updated successfully',
          variant: 'success',
        })
      )
      onClose()
    } catch (err) {
      dispatch(
        showMessage({
          message: 'Error occurred while processing your request',
          variant: 'error',
        })
      )
      console.error(err)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleChange = (e: any) => {
    const {value} = e.target
    setNote(value)
  }

  return (
    <OrderModal
      btnText={value?.id ? 'Save' : 'Add Note'}
      title='Notes'
      onClose={onClose}
      icon='notes'
      onConfirm={handleSaveNote}
      isSubmitting={isSubmitting}
    >
      <textarea
        className='form-control'
        rows={5}
        value={note}
        onChange={handleChange}
        placeholder='Enter a description...'
      />
    </OrderModal>
  )
}

export default CustomerNewNote
